import React from "react";
import { useCountdown } from "../hooks/useCountdown";
const START_SECONDS = 17 * 60 + 34;
export function Countdown({
  tone = "dark"
}: {
  tone?: "dark" | "light";
}) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  const labelColor = tone === "dark" ? "text-white/70" : "text-navy/70";
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-20" data-mp="3c48qcjilh3gx">
      <p className={`text-sm font-bold ${tone === "dark" ? "text-gold" : "text-alert"}`} data-id="element-21" data-mp="3h2k06u8w3dz5">
        The promotional price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-22" data-mp="372t7my3w391p">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="10clayhlz829e" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="10cv0k43407ek">
              <span className="flex h-16 w-16 items-center justify-center rounded-xl bg-alert font-display text-3xl font-extrabold tabular-nums text-white shadow-lg sm:h-20 sm:w-20 sm:text-4xl" data-id="element-25" data-mp="15b6dwosm501j">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase ${labelColor}`} data-id="element-26" data-mp="t1k7p0m8qphw">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 text-3xl font-black ${tone === "dark" ? "text-white" : "text-navy"}`} data-id="element-27" data-mp="12rdabc4enua0">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}